module.exports = __webpack_public_path__ + "img/nft-05.926a986e.jpg";